export default __webpack_public_path__ + "static/media/img3.c083531c.png";